import type { MisconceptionDefinition } from '../types';
export const GELD_BASIS: MisconceptionDefinition[] = [{
  id: 'geld.decimal-comma',
  label: 'Komma vergeten/verkeerd',
  module: 'Geld',
  description: 'Leerling plaatst de decimale komma verkeerd bij geldbedragen.',
  typicalFamilies: ['GELD-GELD-KOMMA']
}, {
  id: 'geld.change-calculation',
  label: 'Wisselgeld verkeerd berekend',
  module: 'Geld',
  description: 'Leerling berekent wisselgeld verkeerd (trekt van het verkeerde bedrag af).',
  typicalFamilies: ['GELD-GELD-TERUG', 'GELD-GELD-TERUGREKENEN']
}, {
  id: 'geld.total-vs-unit-price',
  label: 'Totaalprijs verward met eenheidsprijs',
  module: 'Geld',
  description: 'Leerling vergelijkt totaalprijzen in plaats van de prijs per eenheid (per stuk, per kg, per liter).',
  typicalFamilies: ['GELD-GELD-KOOPJES', 'GELD-GELD-PRIJS-PER']
}, {
  id: 'geld.wrong-division-direction',
  label: 'Verkeerde deelrichting bij eenheidsprijs',
  module: 'Geld',
  description: 'Leerling deelt het aantal door de prijs in plaats van de prijs door het aantal.',
  typicalFamilies: ['GELD-GELD-KOOPJES', 'GELD-GELD-PRIJS-PER']
}, {
  id: 'geld.deling-te-laag',
  label: 'Deelt te laag uit bij spaarberekening',
  module: 'Geld',
  description: 'Leerling deelt het spaardoel door een te laag getal of maakt een delingsfout waardoor het resultaat te laag is.',
  typicalFamilies: ['GELD-GELD-SPAREN']
}, {
  id: 'geld.deling-te-hoog',
  label: 'Deelt te hoog uit bij spaarberekening',
  module: 'Geld',
  description: 'Leerling deelt het spaardoel door een te hoog getal of maakt een delingsfout waardoor het resultaat te hoog is.',
  typicalFamilies: ['GELD-GELD-SPAREN']
}, {
  id: 'geld.verkeerd-deeltal',
  label: 'Gebruikt verkeerd deeltal bij sparen',
  module: 'Geld',
  description: 'Leerling deelt door het verkeerde getal (bijv. door het spaardoel i.p.v. het weekbedrag).',
  typicalFamilies: ['GELD-GELD-SPAREN']
}, {
  id: 'geld.cent-optelling-fout',
  label: 'Telt centen verkeerd op',
  module: 'Geld',
  description: 'Leerling maakt een fout bij het optellen van centen (bijv. 50+75=100 i.p.v. 125).',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.uitgaven-als-wisselgeld',
  label: 'Verwart totale uitgaven met wisselgeld',
  module: 'Geld',
  description: 'Leerling geeft het totaal van de uitgaven als wisselgeld i.p.v. budget minus uitgaven.',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.aftrekken-vergeten',
  label: 'Maakt aftrekfout bij centen',
  module: 'Geld',
  description: 'Leerling maakt een fout bij het aftrekken van centenbedragen.',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.aftrekfout-tientallen',
  label: 'Maakt aftrekfout bij tientallen',
  module: 'Geld',
  description: 'Leerling maakt een fout bij het aftrekken van tientallen (bijv. 150-85=75 i.p.v. 65).',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.aftrekfout-eenheden',
  label: 'Maakt aftrekfout bij eenheden',
  module: 'Geld',
  description: 'Leerling maakt een fout bij het aftrekken van eenheden.',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.optellen-ipv-aftrekken',
  label: 'Telt op in plaats van af te trekken',
  module: 'Geld',
  description: 'Leerling telt bedragen op terwijl aftrekken gevraagd wordt (bijv. bij "hoeveel nog sparen").',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.kosten-hoger-schatten',
  label: 'Schat kosten hoger in dan ze zijn',
  module: 'Geld',
  description: 'Leerling denkt dat de kosten het budget overschrijden terwijl dat niet zo is.',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.precies-genoeg-verwarring',
  label: 'Verwart bijna genoeg met precies genoeg',
  module: 'Geld',
  description: 'Leerling denkt dat het budget precies genoeg is terwijl er geld overblijft of tekort is.',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.aftrekken-ipv-delen',
  label: 'Trekt af in plaats van te delen',
  module: 'Geld',
  description: 'Leerling trekt het weekbedrag af van het spaardoel i.p.v. te delen (bijv. €35-€5=€30 i.p.v. €35÷€5=7).',
  typicalFamilies: ['GELD-GELD-BUDGET']
}, {
  id: 'geld.geen-bewerking',
  label: 'Voert geen bewerking uit (gok of "kan niet")',
  module: 'Geld',
  description: 'Leerling kiest een antwoord zonder de bewerking uit te voeren — bijv. "beide even duur" of "kan je niet uitrekenen" — terwijl een eenvoudige deling/aftrekking de vraag oplost.',
  typicalFamilies: ['GELD-KOOPJES', 'GELD-PRIJS-PER', 'GELD-RENTE-PROC']
}];